import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7862cfaf"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "vod-statistics-warp"
};
const _hoisted_2 = {
  class: "info-warp"
};
const _hoisted_3 = {
  class: "tabs-warp"
};
const _hoisted_4 = {
  class: "right-warp"
};
const _hoisted_5 = {
  class: "icon-warp"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "count-statistics-warp"
};
import TableData from './components/TableData.vue';
import NumStatistics from './components/NumStatistics.vue';
import { useI18n } from 'vue-i18n';
import { nextTick, onMounted } from 'vue';
import dayjs from 'dayjs';
import { getItemByProp } from '@/utils/tools';
import Charts from './components/charts.vue';
import { getMainBrandListApi, getSubBrandListApi, getChannelDataApi, downloadStatisticsApi } from '@/api/live';
import { useCommon } from '@/store/useCommon';
import { ElMessage } from 'element-plus';
import { useBrandsByUser } from '@/utils/cacheData'; // 查询事件

export default /*#__PURE__*/_defineComponent({
  __name: 'index',

  setup(__props) {
    const {
      t
    } = useI18n();
    const loading = ref(false);
    const countStatisticsRef = ref(null);
    const typeObj = {
      'month': 2,
      'week': 3,
      'day': 5
    };
    const charts = ref();
    const tableData = ref([]);
    const channelCountData = ref(null);
    const paginationConfig = ref({
      page: 1,
      limit: 10,
      total: 0
    });
    const isVnoAccount = useCommon().userData.roles.some(item => /VNO/ig.test(item)) || useCommon().userData.roles.includes('CUSTOMER_SN'); //区分是否为vno运营商账号

    const cpspId = isVnoAccount ? useCommon().userData.cid[0] : Number(sessionStorage.getItem('currentCid'));
    const options = ref({
      tooltip: {
        trigger: 'axis'
      },
      toolbox: {
        y: 'bottom'
      },
      legend: {
        bottom: 0,
        icon: 'circle',
        itemWidth: 12,
        itemHeight: 12,
        textStyle: {
          fontSize: 12,
          height: 12,
          lineHeight: 12,
          padding: [0, 0, -3, 0],
          rich: {
            a: {
              verticalAlign: 'middle'
            }
          }
        },
        data: [t('上线频道'), t('新增频道'), t('下线频道'), t('删除频道'), t('更新节目信息'), t('更新图片')]
      },
      xAxis: {
        type: 'category',
        data: [1, 2, 3, 4, 5]
      },
      yAxis: {
        type: 'value'
      },
      series: [{
        name: t('上线频道'),
        type: 'line',
        data: []
      }, {
        name: t('新增频道'),
        type: 'line',
        data: []
      }, {
        name: t('下线频道'),
        type: 'line',
        data: []
      }, {
        name: t('删除频道'),
        type: 'line',
        data: []
      }, {
        name: t('更新节目信息'),
        type: 'line',
        data: []
      }, {
        name: t('更新图片'),
        type: 'line',
        data: []
      }]
    }); // 右侧icon 图标列表

    const iconsList = ref([{
      name: '表格',
      value: 'table',
      defaultUrl: require('./images/ic_list_unsel.png'),
      selectUrl: require('./images/ic_list_sel.png')
    }, {
      name: '折线图',
      value: 'line',
      defaultUrl: require('./images/ic_chart_unsel.png'),
      selectUrl: require('./images/ic_chart_sel.png')
    }, {
      name: '下载',
      value: 'download',
      defaultUrl: require('./images/ic_download_unsel.png'),
      selectUrl: require('./images/ic_download_sel.png')
    }]); // 左侧tabs item默认选中

    const currentLeftTabsSelect = ref(1); // 右侧icon item默认选中

    const currentIconSelect = ref('table');
    const mainAgentIdList = ref([]);
    const agentIdList = ref([]);
    const searchConfig = reactive({
      // size: { sm: 24, md: 12, lg: 8, xl: 6, xs: {} },
      size: {
        sm: 24,
        md: 12,
        lg: 12,
        xl: 6,
        xs: {}
      },
      formList: [{
        label: '品牌',
        prop: 'cid',
        widgetType: 'Select',
        valueKey: 'cid',
        labelKey: 'prefixName',
        list: [],
        disabled: isVnoAccount,
        change: val => {
          sessionStorage.setItem('currentCid', val);
          getMainBrandList();
        }
      }, {
        label: '主品牌',
        prop: 'mainAgentId',
        widgetType: 'Select',
        filterable: true,
        labelKey: 'label',
        valueKey: 'value',
        list: mainAgentIdList,
        change: val => {
          searchConfig.formData.agentId = '';
          getSubBrandList(val);
        },
        controller: () => {
          return true;
        }
      }, {
        label: '子品牌',
        prop: 'agentId',
        widgetType: 'Select',
        filterable: true,
        labelKey: 'label',
        valueKey: 'value',
        list: agentIdList,
        change: val => {},
        controller: () => {
          return true;
        }
      }, {
        label: '时间维度',
        prop: 'timeDimension',
        widgetType: 'Select',
        filterable: true,
        change: val => {},
        translation: true,
        list: [{
          label: '日_s',
          value: 'day'
        }, {
          label: '周_s',
          value: 'week'
        }, {
          label: '月_s',
          value: 'month'
        }]
      }, {
        label: '时间范围',
        prop: 'time',
        widgetType: 'date',
        placeholder: '请选择时间',
        'start-placeholder': t('开始时间'),
        'end-placeholder': t('结束时间'),
        valueFormat: 'x',
        type: 'daterange',
        clearable: false,
        editable: false
      }],
      formData: {
        mainAgentId: '',
        agentId: '',
        timeDimension: 'day',
        time: [] || '',
        cid: cpspId
      },
      search: () => {
        handleSearch();
      },
      reset: async () => {
        paginationConfig.value = {
          limit: 10,
          page: 1,
          total: 0
        };
        agentIdList.value = []; //重置table

        tableData.value = [];
        searchConfig.formData.timeDimension = 'day';
        searchConfig.formData.cid = isVnoAccount ? cpspId : 0; //重置曲线图

        options.value.series.forEach(item => {
          item.data = [];
        });
        charts.value && charts.value.drawChart(); //触发重新渲染
        //重置右侧总计数据

        channelCountData.value = {
          channelCount: 0,
          onLineList: [{
            onLine: 0,
            offLine: 0
          }, {
            onLine: 0,
            offLine: 0
          }, {
            onLine: 0,
            offLine: 0
          }]
        };
        searchConfig.formData.time = [dayjs().startOf('day').format('YYYY-MM-DD'), dayjs().endOf('day').format('YYYY-MM-DD')];
        getChannelData(1, 10);
      }
    });

    const handleCurrentChange = val => {
      paginationConfig.value.page = val;
      getChannelData(paginationConfig.value.page, paginationConfig.value.limit);
    };

    const handleSizeChange = val => {
      paginationConfig.value.limit = val;
      getChannelData(1, paginationConfig.value.limit);
    };

    const handleSearch = async () => {
      console.log('search-formData', searchConfig.formData);
      getChannelData(1, 10);
    };

    const getChannelData = async (page = 1, limit = 10) => {
      const {
        timeDimension,
        mainAgentId,
        agentId,
        cid,
        time
      } = searchConfig.formData;
      if (mainAgentId !== '' && agentId === '') return ElMessage({
        type: 'error',
        message: t('请选择子品牌')
      });
      if (mainAgentId == '' && agentId !== '') return ElMessage({
        type: 'error',
        message: t('请选择主品牌')
      });
      loading.value = true;
      let params = {
        current: page,
        pageSize: limit,
        mainAgentId: mainAgentId === '' ? undefined : mainAgentId,
        agentId: agentId === '' ? undefined : agentId,
        cid,
        type: typeObj[timeDimension],
        startDate: time[0],
        endDate: time[1]
      };
      const {
        code,
        data
      } = await getChannelDataApi(params);

      if (code == 0) {
        paginationConfig.value.limit = data.countList.size;
        paginationConfig.value.page = data.countList.current;
        paginationConfig.value.total = data.countList.total;
        tableData.value = data.countList.records.filter(item => item.createTime !== '合计'); // 折线图x轴坐标名称

        options.value.xAxis.data = data.line.xaxis.data.map(item => {
          if (timeDimension === 'week') {
            let year = item.split('-')[0];
            let week = item.split('-')[1];
            return `${year}${t('年_s')} ${t('第')}${week}${t('周')}`;
          }

          return item;
        });
        data.line.series && data.line.series.forEach((item, index) => {
          options.value.series[index].data = item.data;
        });
        const {
          channelCount,
          onLineList
        } = data;
        channelCountData.value = {
          channelCount,
          onLineList
        };
        nextTick(() => {
          charts.value && charts.value.drawChart(); //触发重新渲染
        });
      }

      loading.value = false;
    }; //监听时间维度的变化


    watch(() => searchConfig.formData.timeDimension, val => {
      setDefaultTime();
    }, {
      // immediate: true,
      deep: true
    });
    const baseForm = ref({
      startDate: '',
      endDate: ''
    }); // 时间戳转为yy-mm-dd

    const getCurrentTime = (data, num) => {
      let date = new Date(data);
      const Y = date.getFullYear();
      const M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      const D = date.getDate() + num < 10 ? '0' + (date.getDate() + num) : date.getDate() + num;
      date = Y + '-' + M + '-' + D;
      return date;
    }; // 设置时间范围默认时间


    const setDefaultTime = () => {
      let datePickConfig = getItemByProp(searchConfig.formList, 'time');

      if (searchConfig.formData.timeDimension == 'day') {
        datePickConfig.key = Date.now();
        datePickConfig.valueFormat = 'YYYY-MM-DD';
        datePickConfig.format = 'YYYY-MM-DD';
        datePickConfig.type = 'daterange'; //searchConfig.formData.time = dayjs().endOf('day').format('YYYY-MM-DD') as any

        searchConfig.formData.time = [dayjs().startOf('day').format('YYYY-MM-DD'), dayjs().endOf('day').format('YYYY-MM-DD')];
      } else if (searchConfig.formData.timeDimension == 'week') {
        datePickConfig.key = Date.now();
        datePickConfig.valueFormat = 'YYYY-MM-DD';
        datePickConfig.format = 'YYYY-MM-DD';
        datePickConfig.type = 'daterange';
        datePickConfig.type = 'daterange';
        searchConfig.formData.time = [dayjs().startOf('week').add(1, 'day').format('YYYY-MM-DD'), dayjs().endOf('week').add(1, 'day').format('YYYY-MM-DD')];
      } else if (searchConfig.formData.timeDimension == 'month') {
        datePickConfig.key = Date.now();
        datePickConfig.valueFormat = 'YYYY-MM';
        datePickConfig.format = 'YYYY-MM';
        datePickConfig.type = 'monthrange'; // searchConfig.formData.time = dayjs().endOf('day').format('YYYY-MM') as any

        searchConfig.formData.time = [dayjs().startOf('month').format('YYYY-MM'), dayjs().endOf('month').format('YYYY-MM')];
      }
    }; // 右侧icons item点击事件


    const rightIconItemClick = item => {
      //console.log('点击的图标',item)
      console.log('tableData', tableData.value);
      currentIconSelect.value = item.value; //请求对应的table|line数据

      switch (item.value) {
        case 'table':
          break;

        case 'line':
          //todo:调接口
          //tableData.value = []
          nextTick(() => {
            charts.value && charts.value.drawChart(); //触发重新渲染
          });
          break;

        case 'download':
          loading.value = true;
          const {
            timeDimension,
            mainAgentId,
            agentId,
            cid,
            time
          } = searchConfig.formData;
          if (mainAgentId !== '' && agentId === '') return ElMessage({
            type: 'error',
            message: t('请选择子品牌')
          });
          if (mainAgentId == '' && agentId !== '') return ElMessage({
            type: 'error',
            message: t('请选择主品牌')
          });
          let params = {
            mainAgentId,
            agentId,
            cid,
            type: typeObj[timeDimension],
            startDate: timeDimension === 'week' ? baseForm.value.startDate : time[0],
            endDate: timeDimension === 'week' ? baseForm.value.endDate : time[1]
          };
          downloadStatisticsApi(params).then(res => {
            const blob = new Blob([res], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const objectUrl = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = objectUrl; // 设置文件名

            a.download = `STATISTICS_${dayjs(new Date()).format('YYYY-MM-DD')}`;
            a.click();
            a.remove();
            window.URL.revokeObjectURL(objectUrl);
            currentIconSelect.value = 'table'; //下载完变回table表格

            loading.value = false;
          }).catch(err => {
            console.log('385download_error', err);
            currentIconSelect.value = 'table'; //下载完变回table表格

            loading.value = false;
          });
          break;
      }
    }; // 获取主品牌


    const getMainBrandList = async () => {
      loading.value = true;
      let cid = isVnoAccount ? useCommon().userData.cid[0] : Number(sessionStorage.getItem('currentCid'));
      const {
        code,
        data
      } = await getMainBrandListApi(cid);

      if (code == 0) {
        mainAgentIdList.value = data;

        if (data && data.length > 0) {//默认选择第一项主品牌
          //searchConfig.formData.mainAgentId = data[0].value
        }
      }

      loading.value = false;
    }; // 获取子品牌


    const getSubBrandList = async mainAgentId => {
      loading.value = true;
      const {
        code,
        data
      } = await getSubBrandListApi(mainAgentId);

      if (code == 0) {
        agentIdList.value = [...data];
      }

      loading.value = false;
    }; // 获取品牌选项数据


    const getBrands = async () => {
      const brands = await useBrandsByUser();
      let searchItem = getItemByProp(searchConfig.formList, 'cid');
      if (searchItem) searchItem.list = brands;
      const cid = cpspId;

      if (!cid) {
        sessionStorage.setItem('currentCid', brands[0].cid);
      }
    }; // 左侧表格/echart图例信息容器总高度


    const tableWarpClientHeight = ref(0); // 表格/echart图例最大高度

    const tableMaxHeight = ref(0);
    onMounted(() => {
      tableWarpClientHeight.value = countStatisticsRef.value.$el.clientHeight;
      let tabWarp = document.querySelector('.tabs-warp');
      tableMaxHeight.value = countStatisticsRef.value.$el.clientHeight - (tabWarp.clientHeight + 20 + 50 + 36);
      console.log('tableMaxHeight', tableMaxHeight); // 监听页面尺寸变化 获取右侧统计数量容器高度赋值给左侧容器 达成两边相同高度

      window.addEventListener('resize', () => {
        // console.log(countStatisticsRef.value.$el.clientHeight);
        if (countStatisticsRef.value) {
          tableWarpClientHeight.value = countStatisticsRef.value.$el.clientHeight;
          let tabWarp = document.querySelector('.tabs-warp');
          tableMaxHeight.value = countStatisticsRef.value.$el.clientHeight - (tabWarp.clientHeight + 20 + 50 + 36);
          console.log('tableMaxHeight', tableMaxHeight);
        }
      }, {
        passive: false
      });
    });
    onMounted(async () => {
      getBrands();
      await setDefaultTime();
      await getMainBrandList();
      await getChannelData();
    });
    return (_ctx, _cache) => {
      const _component_search_form = _resolveComponent("search-form");

      const _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_search_form, {
        size: searchConfig.size,
        gutter: 50,
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        onSearch: searchConfig.search,
        onReset: searchConfig.reset
      }, null, 8, ["size", "form-list", "form-data", "onSearch", "onReset"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "table-chart-warp cms-card-block",
        style: _normalizeStyle('height: ' + tableWarpClientHeight.value + 'px')
      }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(iconsList.value, (item, index) => {
        return _openBlock(), _createElementBlock("span", {
          class: "pointer",
          key: index,
          onClick: $event => rightIconItemClick(item)
        }, [_createElementVNode("img", {
          src: currentIconSelect.value == item.value ? item.selectUrl : item.defaultUrl,
          alt: ""
        }, null, 8, _hoisted_7)], 8, _hoisted_6);
      }), 128))])])]), _createElementVNode("div", {
        class: "data-warp",
        style: _normalizeStyle('height: ' + tableMaxHeight.value + 'px')
      }, [_withDirectives(_createVNode(TableData, {
        data: tableData.value,
        "max-height": tableMaxHeight.value,
        paginationConfig: paginationConfig.value,
        onCurrentChange: handleCurrentChange,
        onSizeChange: handleSizeChange,
        timeDimension: searchConfig.formData.timeDimension
      }, null, 8, ["data", "max-height", "paginationConfig", "timeDimension"]), [[_vShow, currentIconSelect.value == 'table']]), currentIconSelect.value == 'line' ? (_openBlock(), _createBlock(Charts, {
        key: 0,
        option: options.value,
        ref_key: "charts",
        ref: charts
      }, null, 8, ["option"])) : _createCommentVNode("", true)], 4)], 4), _createElementVNode("div", _hoisted_8, [_createVNode(NumStatistics, {
        title: 'aaaaaa',
        ref_key: "countStatisticsRef",
        ref: countStatisticsRef,
        data: channelCountData.value
      }, null, 8, ["data"])])])])), [[_directive_loading, loading.value]]);
    };
  }

});